import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { Dropdown } from '../../../legacy-design-system/dropdown'
import { FormattedMessage } from 'react-intl'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'

function AngularIntegrationsDropdown(props) {
  return (
    <Dropdown
      {...props}
      styleOverrides={{
        outerContainerCss: css`
          width: 100%;
          position: absolute;
          display: flex;
          flex-direction: column;
          padding-right: 20px;
        `,
        selectionContainerCss: css`
          min-width: 250px;
          background-color: white;
          background-image: unset;
          background-color: ${theme.color.white};
          border-color: ${theme.color.neutral50};
        `,
        menuCss: css`
          min-width: 250px;
        `
      }}
      menuFooterRenderer={
        !!props.menuFooterMessage &&
        (() => {
          return <FormattedMessage {...props.menuFooterMessage} />
        })
      }
    />
  )
}

export const reactIntegrationsDropdown = createNgReactBridgeDirective(
  'reactIntegrationsDropdown',
  [],
  AngularIntegrationsDropdown,
  [
    'items',
    'selectedItem',
    'itemToString',
    'itemToKey',
    'onChange',
    'menuFooterMessage',
    'itemToGroup'
  ]
)
